import { render } from "./ThePageLoading.vue?vue&type=template&id=103180e9&ts=true"
import script from "./ThePageLoading.vue?vue&type=script&lang=ts"
export * from "./ThePageLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__